import { UserProfile } from "src/components/user-profile";

export const checkAuthByUser =(userProfile: UserProfile )=> {
    return userProfile && userProfile.roles &&
        (userProfile.roles.includes("Manager") || userProfile.roles.includes("Administrator")
            || userProfile.roles.includes("ClientAdmin") || userProfile.roles.includes("FIConsultant")
            || userProfile.roles.includes("CompanyDataViewer"));
}

export const checkLogAuth = (userProfile: UserProfile) =>{
    return userProfile && userProfile.roles &&
        (userProfile.roles.includes("Administrator")
            || userProfile.roles.includes("ClientAdmin")
            || userProfile.roles.includes("FIConsultant")
            || userProfile.roles.includes("CompanyDataViewer"));
}

export const isReadOnly =(userProfile: UserProfile)=> {
    return userProfile && userProfile.roles &&
        (userProfile.roles.includes("CompanyDataViewer")
            && !(userProfile.roles.includes("Manager")
                || userProfile.roles.includes("Administrator")
                || userProfile.roles.includes("ClientAdmin")
                || userProfile.roles.includes("FIConsultant")));
}

export const checkAuthAdmin = (userProfile: UserProfile) => {
    return userProfile && userProfile.roles && (userProfile.roles.includes("Administrator") || userProfile.roles.includes("ClientAdmin") || userProfile.roles.includes("FIConsultant"))
}

export const checkAuthAdminFi = (userProfile: UserProfile) => {
    return userProfile && userProfile.roles && (userProfile.roles.includes("FIConsultant"))
}